/**
 * The dashboard's Campaigns card, as facts (WAPP-DASH, owner 2026-10-28): which campaigns qualify, why, and in what
 * order. Moved from the portal's `apps/web-app/src/routes/dashboard/campaign-card.tsx` (plan-034 VIEW-PKG), which keeps
 * the words and the markup and re-exports these.
 *
 *   - WHAT QUALIFIES. (a) running or paused now; (b) starting soon: `scheduled` with `starts_at` no more than 24 hours
 *     ahead (a start already passed that has not begun dialling still counts — it is due); (c) ending soon: running with
 *     `estimated_finish_at` no more than 24 hours ahead.
 *   - HOW MANY, IN WHAT ORDER. At most five: running first, then ending soon (soonest end first), then paused, then
 *     starting soon (soonest start first); a stable sort, so within running and paused the VoiceAgents' order and each
 *     list's own (newest first) are kept.
 */
/** The card's longest list. */
export const CAMPAIGN_CARD_ROW_LIMIT = 5;
/** "Soon": within a day. */
export const CAMPAIGN_SOON_MS = 24 * 3_600_000;
const GROUP_RANK = { running: 0, ending_soon: 1, paused: 2, starting_soon: 3 };
function untilMs(isoTimestamp, now) {
    return new Date(isoTimestamp).getTime() - now.getTime();
}
/** Why `one` is on the card, or `null` when it is not. */
export function campaignCardGroupOf(one, now) {
    if (one.state === "paused" || (one.state === "running" && one.diallingState === "paused"))
        return "paused";
    if (one.state === "running") {
        return one.estimatedFinishAt !== null && untilMs(one.estimatedFinishAt, now) <= CAMPAIGN_SOON_MS ? "ending_soon" : "running";
    }
    if (one.state === "scheduled" && one.startsAt !== null && untilMs(one.startsAt, now) <= CAMPAIGN_SOON_MS) {
        return "starting_soon";
    }
    return null;
}
/** The instant a group is ranked by within itself: the end for ending soon, the start for starting soon. */
function rankInstantOf(row) {
    if (row.group === "ending_soon" && row.campaign.estimatedFinishAt !== null)
        return new Date(row.campaign.estimatedFinishAt).getTime();
    if (row.group === "starting_soon" && row.campaign.startsAt !== null)
        return new Date(row.campaign.startsAt).getTime();
    return 0;
}
/** The qualifying campaigns of every VoiceAgent, ranked, at most {@link CAMPAIGN_CARD_ROW_LIMIT}. */
export function campaignCardRowsOf(owned, now) {
    const found = [];
    for (const voiceAgent of owned) {
        for (const one of voiceAgent.campaign) {
            const group = campaignCardGroupOf(one, now);
            if (group !== null)
                found.push({ campaign: one, voiceAgentId: voiceAgent.voiceAgentId, voiceAgentName: voiceAgent.voiceAgentName, group });
        }
    }
    return found
        .map((row, index) => ({ row, index }))
        .sort((a, b) => GROUP_RANK[a.row.group] - GROUP_RANK[b.row.group] || rankInstantOf(a.row) - rankInstantOf(b.row) || a.index - b.index)
        .slice(0, CAMPAIGN_CARD_ROW_LIMIT)
        .map((one) => one.row);
}
//# sourceMappingURL=campaign-card-group.js.map